module.exports = __webpack_public_path__ + "img/nosotros_sidebar.91a45ba9.jpg";